import { useState } from "react";
import Formbody from './Formbody';
import { Post } from "utils/request";
import { useDispatch} from "react-redux";
import { Show } from "actions/SnackbarActions";
import SweetAlert from "react-bootstrap-sweetalert";

const AsideBannerAdd = () => {
    const [popup, SetPopup] = useState(false);
    const [popupMessage, SetPopupMessage] = useState("");

    const [loading, SetLoading] = useState(false);

    const dispatch = useDispatch();

    const Submit = async (data) => {
        let form = new FormData();
        form.append("banner", data?.banner);
        form.append("link", data?.link);

        SetLoading(true);
        let response = await Post("site-rt/aside-banner/create", form);
        SetLoading(false);

        dispatch(Show({
            show: true,
            message: response?.message,
            severity: response?.severity
        }));
    }

    return (
        <div className="card">
            <SweetAlert
                warning
                show={popup}
                title="Atenção!"
                confirmBtnText="Ok"
                onConfirm={() => SetPopup(false)}
            >
                {popupMessage}
            </SweetAlert>
            <div className="card-body">
                <h2 className="title">
                    Editar banner da lateral do site RT
                </h2>
                <p>Aqui é editado o banner da lateral da página RT</p>
                <br/>
                <span style={{ color: "#888" }}>Tamanho recomendado: 182x420</span>
                <p style={{ color: "#888" }}>Proporção do banner: 13 : 30</p>
                <Formbody
                    OnConfirm={data => Submit(data)}
                    loading={loading}
                />
            </div>
        </div>
    );
}

export default AsideBannerAdd;